<template>
    <MapViewer
        class="o-terminal-map-controller terminal-map-controller"
        :map-data="getMvData"
        :active-view="activeView"
        :is-reactive="false"
        @ready="onMapReady"
        ref="mapViewer"
    >
        <OMapGuideViews @changeView="setActiveView"></OMapGuideViews>
    </MapViewer>
</template>

<script>
import { mapGetters } from 'vuex';
import OMapGuideViews from "../o-map-guide-views/o-map-guide-views";
import MapViewer from "../../../shared/components/map-viewer/map-viewer";

export default {
    name: "OTerminalMapController",
    components: {
        MapViewer,
        OMapGuideViews,
    },
    data() {
        return {
            activeView: 'OutdoorView',
            isMapReady: false,
        }
    },
    computed: {
        ...mapGetters([
            'getMvData',
            'getTerminalUnit'
        ]),
    },
    methods: {
        onMapReady() {
            this.isMapReady = true
            this.$store.commit('setMapLoading', false);
            this.requestUnitDistances()
        },
        requestUnitDistances(){
            const calcForTypes = ['tenant', 'service']
            const request = {
                from: { unit: this.getMvData.terminalUnitName },
                to: Object.values(
                    this.getMvData.objects.reduce((acc, o) => {
                        if(calcForTypes.includes(o.type))
                            acc[o.unit.name] = { unit: o.unit.name }
                        return acc
                    }, {} )
                )
            };
            this.$refs.mapViewer.getUnitDistances(request);
        },
        setUnitDistances(distances){
            this.$store.commit("setObjectDistances", distances)
        },
        setActiveView(activeView){
            this.activeView = activeView
        }
    },
    mounted() {
        this.$bus.$on("ui:unitDistances", this.setUnitDistances);
    },
    beforeDestroy() {
        this.$bus.$off("ui:unitDistances", this.setUnitDistances);
    }
}
</script>

<style lang="scss">
@import "terminal-map-controller";
</style>
